<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl">🚀</span>
        <span>职业发展路径规划</span>
      </h2>
      <p class="text-gray-600 text-lg">从现在到未来，您的成长之路</p>
    </div>

    <div class="grid md:grid-cols-2 gap-6">
      <!-- 短期目标 -->
      <div class="p-7 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border-2 border-blue-300">
        <h3 class="text-xl font-bold text-blue-900 mb-5 flex items-center gap-2">
          <span class="text-2xl">🎯</span>
          <span>短期目标</span>
        </h3>
        <p class="text-sm text-blue-700 mb-4">接下来1-2年内的重点发展方向</p>
        <ul class="space-y-3">
          <li
            v-for="(item, index) in path.shortTerm"
            :key="index"
            class="flex items-start gap-3"
          >
            <div class="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
              {{ index + 1 }}
            </div>
            <span class="text-base leading-relaxed text-blue-900 font-medium pt-1">{{ item }}</span>
          </li>
        </ul>
      </div>

      <!-- 长期目标 -->
      <div class="p-7 bg-gradient-to-br from-green-50 to-green-100 rounded-xl border-2 border-green-300">
        <h3 class="text-xl font-bold text-green-900 mb-5 flex items-center gap-2">
          <span class="text-2xl">🌟</span>
          <span>长期目标</span>
        </h3>
        <p class="text-sm text-green-700 mb-4">未来3-5年的职业发展愿景</p>
        <ul class="space-y-3">
          <li
            v-for="(item, index) in path.longTerm"
            :key="index"
            class="flex items-start gap-3"
          >
            <div class="flex-shrink-0 w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
              {{ index + 1 }}
            </div>
            <span class="text-base leading-relaxed text-green-900 font-medium pt-1">{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 行动提示 -->
    <div class="mt-6 p-5 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl border border-purple-200">
      <p class="text-sm text-gray-700 leading-relaxed flex items-start gap-3">
        <span class="text-xl flex-shrink-0">💡</span>
        <span>
          <strong class="text-purple-700">温馨提示：</strong>
          职业发展是一个动态的过程。建议每半年回顾一次这些目标，根据实际情况调整计划。记住，每一个小步骤的积累，都会带您更接近理想的职业状态！
        </span>
      </p>
    </div>
  </div>
</template>

<script>
/**
 * 职业发展路径规划组件
 * 展示短期和长期的职业发展目标
 */
export default {
  name: 'CareerPathPlanning',
  props: {
    path: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.shortTerm && value.longTerm
      }
    }
  }
}
</script>

